module.exports = __webpack_public_path__ + "static/media/cha.afc4ee60.png";